import './notifications.css'
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import {
    Notification,
    NotificationGroup,
} from "@progress/kendo-react-notification";
import parse from 'html-react-parser';
import { isNullOrEmpty } from '../helpers/ObjectHelpers';
import { addClassToElementByClassName } from '../helpers/ElementHelpers';
import { useNotificationMessage, useCloseNotificationMessageId, useSetCloseNotificationMessageId } from '../hooks/useAppStore';

export default function Notifications(
    
) {
    const [notifications, setNotifications] = useState([]);
    const componentRef = useRef({
        ids: [],
        systemNames: []
    });
    const { current: localRef } = componentRef;

    const notificationMessage = useNotificationMessage();
    const closeNotificationMessageId = useCloseNotificationMessageId();
    const setCloseNotificationMessageId = useSetCloseNotificationMessageId();

    useEffect(() => {
        if (!notificationMessage) return;
        addNotification(notificationMessage);
    }, [notificationMessage]);

    useEffect(() => {
        if (!closeNotificationMessageId) return;
        closeNotification(closeNotificationMessageId);
    }, [closeNotificationMessageId]);

    return (
        (!isNullOrEmpty(notifications)) &&
            <NotificationGroup className="k-notification-group" >
                {
                    notifications.map((notification) => (
                        <NotificationCard
                            key={notification.id}
                            notification={notification}
                            onClick={onClick}
                            handleFadeout={handleFadeout}
                            />
                    ))
                }
            </NotificationGroup>
    );

    function addNotification(data) {
        let existing = localRef.ids.find(id => id === data.id);
        if (existing) return;
        
        if ('systemName' in data) {
            existing = localRef.systemNames.find(x => x === data.systemName);
            if (existing) return;
        }

        setNotifications(prev => [
            ...prev,
            data
        ]);

        localRef.ids.push(data.id);
        if (!isNullOrEmpty(data.systemName)) {
            localRef.systemNames.push(data.systemName);
        }
        
    }

    function closeNotification(data) {
        const notification = notifications.find(n => n.id === data);
        if (notification && !isNullOrEmpty(notification.systemName)) {
            localRef.systemNames = localRef.systemNames.filter(x => x !== notification.systemName);
        }

        setNotifications(prev => {
            return prev.filter(n => n.id !== data);
        });

        localRef.ids = localRef.ids.filter(id => id !== data);
    }

    function onClick(notification) {
        setNotifications(prev => {
            return prev.filter(n => n.id !== notification.id);
        });

        localRef.ids = localRef.ids.filter(id => id !== notification.id);

        if (!isNullOrEmpty(notification.systemName)) {
            localRef.systemNames = localRef.systemNames.filter(systemName => systemName !== notification.systemName);
        }

        setCloseNotificationMessageId(notification.id);
    }

    function handleFadeout(notification) {
        setTimeout(() => {
            onClick(notification);
        }, 4500);
    }
}

const NotificationCard = ({ notification, onClick, handleFadeout }) =>
{

    useEffect(() => {
        if (notification.fadeout) {
            onHandleFadeout();
        }
    }, [])

    return (
        <Notification
            className={`k-notification ${notification.id}`}
            type={{
                style: notification.type,
                icon: false,
            }}
            closable={true}
            onClose={() => onClick(notification)}>
            <span>{parse(notification.text)}</span>
        </Notification>
    );

    function onHandleFadeout() {
        setTimeout(() => {
            addClassToElementByClassName(notification.id, 'k-notification-fadeout');
        }, 100);
        handleFadeout(notification);
    }
}
